import { render } from "./cliente-editar.vue?vue&type=template&id=2be62631"
import script from "./cliente-editar.vue?vue&type=script&lang=js"
export * from "./cliente-editar.vue?vue&type=script&lang=js"

import "./cliente-editar.vue?vue&type=style&index=0&id=2be62631&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__